import React, { useEffect, useState } from "react";
import queryString from "querystring";
import { useNavigate } from "react-router";

const FallbackHandler = () => {
    const [spotifyCode, setSpotifyCode] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        console.log(`fallback: ${window.location}`);
        if (window.location.hash.includes('callback') && window.location.search) {
            const { code, state } = queryString.parse(window.location.search.substring(1));
            if (code) {
                navigate(`/callback?code=${code}&state=${state||'state'}`);
            }
        } 
    }, []);

    return (
        <div className="text-center">
            <div style={{height: "30vh"}} />
            <div style={{height: "70vh"}} />
        </div>
);
}

export default FallbackHandler;